export function disbledAssetOption(relatedAssets, asset) {
  let result = false;
  if (relatedAssets.length) {
    const relatedAsset = relatedAssets.find((r) => {
      return r.uuid === asset.uuid;
    });
    if (
      relatedAsset?.assetCheckStatus &&
      (relatedAsset.assetCheckStatus !== 'NONE' || relatedAsset.assetCheckComments !== '')
    ) {
      result = true;
    }
  }
  return result;
}
